import {
  FichaCadastralDTO,
  FichaCadastralMoradorDTO,
  ReservaFNRHDTO,
} from './../core/types';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { PessoaDTO, ReservaDTO } from '../core/types';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss'],
})
export class RegistrationFormComponent {
  public fichaCadastral = {} as FichaCadastralDTO;
  public reserva = {} as ReservaDTO;
  public fnrh = {} as ReservaFNRHDTO;
  public show: string = '';
  public showFnrhForm: boolean = false;
  public pessoa = {} as PessoaDTO;
  public typeRent: string | null = null;
  public tipoLocatarioList = [
    { label: 'Morador principal', value: 'PRINCIPAL' },
    { label: 'Outra pessoa', value: 'ANOTHER' },
  ];
  public loadingReserva = false;
  public sendingForm = false;

  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private router: Router,
  ) {}

  savePrincipalResident(event: FichaCadastralMoradorDTO) {
    this.fichaCadastral.moradorPrincipal = event;
    this.show = '';
  }

  async submitPrincipal(event: FichaCadastralMoradorDTO) {
    this.fichaCadastral.moradorPrincipal = event;
    this.show = '';
  }

  async submitLocatario(event: PessoaDTO) {
    if (this.typeRent === 'ANOTHER') {
      if (event.tipo === 'FISICA') {
        this.fichaCadastral.tipoLocatario = 'OUTRA_PESSOA_FISICA';
      } else {
        this.fichaCadastral.tipoLocatario = 'PESSOA_JURIDICA';
      }
    }
    this.fichaCadastral.locatario = event;
    this.show = '';
  }

  async submitMorador(event: FichaCadastralMoradorDTO, indexMorador: number) {
    const documento = event.pessoa.documento;
    const isDuplicado = this.fichaCadastral.demaisMoradores
      .filter((_, i) => i !== indexMorador) // ignora o item atual
      .some((morador) => morador.pessoa.documento === documento);

    if (isDuplicado) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Já existe um morador cadastrado com esse documento!',
        showConfirmButton: true,
      });
    } else {
      this.fichaCadastral.demaisMoradores[indexMorador] = event;
      this.show = '';
    }
  }

  async submitFNRH(event: ReservaFNRHDTO) {
    this.fichaCadastral.fnrh = event;
    this.fnrh = event;
    this.showFnrhForm = false;
  }

  ngOnInit(): void {
    this.loadInitial();
  }

  loadInitial() {
    this.loadingReserva = true;
    this.route.params.subscribe((params) => {
      if (params['uuid']) {
        this.api
          .getFicha(params['uuid'])
          .pipe(take(1))
          .subscribe({
            next: (res) => {
              this.loadingReserva = false;
              this.reserva = res.reserva;
              this.fnrh = res?.fnrh ? res.fnrh : ({} as ReservaFNRHDTO);
              this.fichaCadastral.fnrh = res?.fnrh
                ? res.fnrh
                : ({} as ReservaFNRHDTO);
              this.fichaCadastral.reservaUuid = res.reserva.uuid;
              this.fichaCadastral.tipoLocatario =
                this.reserva.contratoCliente.tipoLocatario;
              this.getMoradorPrincipal(res.reserva);
              this.getDemaisMoradores(res.reserva);
            },
            error: (err) => {
              this.loadingReserva = false;
              this.router.navigate(['/404']);
            },
          });
      }
    });
  }

  getMoradorPrincipal(reserva: ReservaDTO) {
    let morador = reserva.moradores.find((el) => el.moradorPrincipal === true);
    console.log('principa', morador);
    if (morador?.uuid) {
      console.log('aqui');
      this.api
        .getPessoa(morador?.pessoaUuid)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            console.log('aqui 2', morador?.uuid, res);
            if (!this.fichaCadastral.moradorPrincipal) {
              this.fichaCadastral.moradorPrincipal =
                {} as FichaCadastralMoradorDTO;
            }

            if (morador?.uuid) {
              this.fichaCadastral.moradorPrincipal.moradorUuid = morador?.uuid;
            }
            this.fichaCadastral.moradorPrincipal.pessoa = res;
            console.log('fichaa', this.fichaCadastral);
            this.getLocatario(reserva);
          },
          error: (err) => {
            this.loadingReserva = false;
            return {} as PessoaDTO;
          },
        });
    } else {
      this.fichaCadastral.moradorPrincipal = {} as FichaCadastralMoradorDTO;
      this.show = 'principal';
      this.loadingReserva = false;
    }
  }

  getDemaisMoradores(res: ReservaDTO) {
    let demaisMoradores = res.moradores.filter(
      (el) => el.moradorPrincipal === false,
    );
    this.fichaCadastral.demaisMoradores = [];
    demaisMoradores.map((el) => {
      this.api
        .getPessoa(el.pessoaUuid)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            this.fichaCadastral.demaisMoradores.push({
              pessoa: res,
              moradorUuid: el.uuid,
            });
          },
          error: (err) => {
            return;
          },
        });
    });
  }

  getLocatario(res: ReservaDTO) {
    if (res.contratoCliente.tipoLocatario === 'MORADOR_PRINCIPAL') {
      this.fichaCadastral.locatario =
        this.fichaCadastral.moradorPrincipal.pessoa;
      this.typeRent = 'PRINCIPAL';
    } else {
      this.typeRent = 'ANOTHER';
      this.api
        .getPessoa(res.contratoCliente.locatario.uuid)
        .pipe(take(1))
        .subscribe({
          next: (res) => {
            this.fichaCadastral.locatario = res;
            this.loadingReserva = false;
          },
          error: (err) => {
            this.loadingReserva = false;
            return {} as PessoaDTO;
          },
        });
    }
  }

  addMorador() {
    if (this.fichaCadastral.demaisMoradores) {
      this.fichaCadastral.demaisMoradores.push({
        pessoa: {},
      } as FichaCadastralMoradorDTO);
    } else {
      this.fichaCadastral.demaisMoradores = [
        { pessoa: {} } as FichaCadastralMoradorDTO,
      ];
    }
    this.show = `resident${this.fichaCadastral.demaisMoradores.length - 1}`;
    setTimeout(() => {
      let element = document.getElementById(
        `resident${this.fichaCadastral.demaisMoradores.length - 1}`,
      );
      element?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }

  removeMorador(index: number) {
    if (this.fichaCadastral.demaisMoradores[index].moradorUuid) {
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Deseja remover morador?',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((result) => {
        if (result) {
          if (this.fichaCadastral.demaisMoradores[index].moradorUuid) {
            this.api
              .deleteMorador(
                this.fichaCadastral.demaisMoradores[index].moradorUuid || '',
              )
              .pipe(take(1))
              .subscribe({
                next: (res) => {
                  Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Morador removido com sucesso!',
                    showConfirmButton: true,
                  }).then(() => {
                    this.loadInitial();
                  });
                },
                error: (err) => {
                  Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Erro ao remover morador!',
                    text: err.error?.message ?? '',
                    showConfirmButton: true,
                  }).then(() => {
                    this.loadInitial();
                  });
                },
              });
          }
        }
      });
    } else {
      this.fichaCadastral.demaisMoradores.splice(index, 1);
    }
  }

  changeRenter(event: string) {
    switch (event) {
      case 'PRINCIPAL':
        this.fichaCadastral.locatario =
          this.fichaCadastral.moradorPrincipal.pessoa;
        this.fichaCadastral.tipoLocatario = 'MORADOR_PRINCIPAL';
        this.typeRent = 'PRINCIPAL';
        this.show = '';
        break;
      case 'ANOTHER':
        this.typeRent = 'ANOTHER';
        this.fichaCadastral.locatario = {} as PessoaDTO;
        break;
      default:
        this.fichaCadastral.locatario = {} as PessoaDTO;
        this.show = '';
        break;
    }
  }

  enviarFicha() {
    const podeEnviar =
      this.isReservaRascunho() ||
      (this.fichaCadastral.moradorPrincipal?.pessoa?.nome &&
        this.fichaCadastral.locatario?.nome);

    if (podeEnviar) {
      this.sendingForm = true;
      this.api.postFicha({ ...this.fichaCadastral }).subscribe({
        next: () => {
          this.sendingForm = false;
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Ficha Cadastral enviada com sucesso!',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.loadInitial();
          });
        },
        error: (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            confirmButtonColor: '#E67142',
            text:
              err.error.message ?? 'Algo deu errado ao enviar ficha cadastral.',
          });
          this.sendingForm = false;
        },
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Formulário incompleto',
        confirmButtonColor: '#E67142',
        text: 'O morador principal e o locatário são obrigatórios!',
      });
    }
  }

  canEditIfMoradorPrincipalIsLocatario() {
    if (
      this.fichaCadastral.locatario.uuid ==
      this.fichaCadastral.moradorPrincipal.pessoa.uuid
    ) {
      return;
    }

    this.show = 'principal';
  }

  disableButton() {
    if (
      this.reserva?.status === 'FINALIZADA' ||
      this.reserva?.status === 'CANCELADA'
    ) {
      return true;
    }

    return false;
  }

  changeFnrhVisibility() {
    this.showFnrhForm = !this.showFnrhForm;
  }

  isReservaRascunho(): boolean {
    return this.reserva?.status === 'RASCUNHO';
  }
}
